import { Component } from '@angular/core';

@Component({
  selector: 'app-recover-password-done',
  templateUrl: './recover-password-done.component.html',
  styleUrls: ['./recover-password-done.component.css']
})
export class RecoverPasswordDoneComponent { }



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/auth/recover-password/recover-password-done/recover-password-done.component.ts